<template>
  <div class="box">
      <Header></Header>

      <section>

        <div style="width: 100%;">
            <div class="block" style="width: 100%;">
                <el-carousel :interval="2000" height="150px">
                    <el-carousel-item v-for="(item, i) in banner" :key="i">
                        <img style="width: 100%; height: 100%;height:150px" @click="bannerJump()" :src="item.path" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <!-- " :style="{marginBottom: typefaces == 1 ? '140px' : '130px' }"-->
		<div class="nav" :style="{marginBottom: typefaces == 1 ? '130px' : '140px' }" style="padding: 0 10px;margin-top: 10px;">
            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '公司新闻' : 'Corporate News'}}</p>
            <p style="font-size: 16px;color: #090909;font-weight: bold;padding-top: 20px;padding-bottom:10px;">{{typefaces == 1 ? tltleData.name : tltleData.nameEng}}</p>
            <p class="zhaiyao" style="font-size: 14px;color:#909090;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 5;line-clamp: 5; -webkit-box-orient: vertical;" @click="jump(1, tltleData.id)">{{typefaces == 1 ? '摘要' : 'Abstract'}}：{{typefaces == 1 ? tltleData.text : tltleData.textEng}}</p>
            <ul style="padding-top: 20px;">
                <div v-for="(item, i) in nav_bottom" :key="i">
                    <li @click="jump(1, item.id)"><img src="../../img/首页/11.png" alt=""><p>{{typefaces == 1 ? item.name : item.nameEng}}</p></li>
                </div>
            </ul>
            <p class="chakan" style="margin-top:20px;margin-bottom:15px;width: 100%;height:48px;border:1px solid #BB1E10;font-size: 13px;color:#BB1E10;display: flex;justify-content: center;align-items: center;" @click="see('/CompanyNews')">{{typefaces == 1 ? '查看更多' : 'See More'}}＞</p>
            <img style="width: 100%;height:auto;margin-top:10px;margin-bottom:15px;" @click="bannerJump()" src="../../img/heelow.png" alt="">
            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '行业资讯' : 'Business'}}</p>
            <ul style="padding-top: 20px;">
                <div v-for="(item, i) in nav_bottoms" :key="i">
                    <li @click="jump(2, item.id)"><img src="../../img/首页/11.png" alt=""><p>{{typefaces == 1 ? item.name : item.nameEng}}</p></li>
                </div>
            </ul>
            <p class="gengduo" style="margin-top: 20px;width: 100%;height:48px;border:1px solid #BB1E10;font-size: 13px;color:#BB1E10;display: flex;justify-content: center;align-items: center;" @click="see('/Industry')">{{typefaces == 1 ? '查看更多' : 'See More'}}＞</p>
        </div>

        <Footer :typeFaces="typeFacesNumber" ></Footer>
      </section>
  </div>
</template>

<script>
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

export default {
	name: 'helloworld',
	components: {
		Header,
        Footer
	},
	data () {
		return {
			banner: [],
			tltleData: {},
			nav_bottom: [],
			nav_bottoms: [],
            typefaces: 1,
            typeFacesNumber: 0
		}
	},

    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch: {
        aaa(type) {
            this.typefaces = type;
        }
    },

	mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
		this.getData(this.typefaces);
		this.getTitle();
		this.getList();
		this.getLists();
	},

	methods: {

        fatherMethod(type){
            this.typefaces = type;
            this.typeFacesNumber = type;
            this.getData(type);
        },

		// 获取轮播图
		getData(type) {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
					type: 0,
					pathEng: type == 1 ? 0 : 1
				},
			}).then( res => {
				this.banner = res.data[0]
			});
		},

		// 获取公司新闻标题
		getTitle() {
            axios({
                url: this.url + '/content/input/fileList',
                method: 'post',
                data: {
                    parentId: 0,
                    type: 8
                },
            }).then( res => {
                this.tltleData = res.data[0][0];
            });
        },

		//公司新闻列表
        getList() {
            axios({
                url: this.url + '/content/input/fileList',
                method: 'post',
                data: {
                    parentId: 0,
                    type: 5
                },
            }).then( res => {
                this.nav_bottom = res.data[0];
            });
        },

		// 行业资讯列表
        getLists() {
            axios({
                url: this.url + '/content/input/fileList',
                method: 'post',
                data: {
                    parentId: 0,
                    type: 7
                },
            }).then( res => {
                this.nav_bottoms = res.data[0];
            });
        },

        // 查看更多
        see(router) {
            this.$router.push(router);
        },

        // 跳转详情页
        jump(text, id) {
            this.$router.push({path:'/Details', name:'Details', query:{text:text,id:id}});
        },

        // 跳转公司新闻
        bannerJump() {
            this.$router.push('/CompanyNews');
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

.banner_wxh {
    position: absolute;
    top: 40px;
    right: 10px;
    z-index: 999;
    display: none;
    background: red;
}

section {
    flex: 1;
    overflow-y: scroll;
}

ul li {
    display: flex;
    padding-bottom: 10px;
}
ul li img {
    width: 6px;
    height:6px;
    margin-top: 8px;
}
ul li p {
    padding-left: 5px;
    font-size: 15px;
    color:#323232;
    text-decoration: none;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}

.footer {
    display: flex;
    flex-wrap: wrap;
    background: #FFFFFF;
    padding-top: 30px;
}
.footer p {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}
.footer p a {
    color:#8E8D8D;
    font-size: 14px;
    text-decoration: none;
}

a {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue